export const FooterHandlers = () => {
    const toggles = document.querySelectorAll<HTMLButtonElement>(
        ".footer__nav .navList li.hasChildren > .icon"
    );

    toggles.forEach((toggle) => {
        toggle.addEventListener("click", (event) => {
           toggleNavOpenState(event);
        });
    });
};

const toggleNavOpenState = (event: Event) => {
    event.stopPropagation();
    const target = event.target as HTMLElement;

    if (!target) return;

    const parent = target.parentElement;
    const isOpening = !parent?.classList.contains("open");

    // Close all other open items
    if (isOpening) {
        const openItems = document.querySelectorAll<HTMLElement>(".footer__nav .navList li.hasChildren.open");
        openItems.forEach((item) => {
            if (item !== parent) {
                item.classList.remove("open");
            }
        });
    }

    parent?.classList.toggle("open");
};
